export enum BilingualFallbackType {
    NATIVE = 'NATIVE',
    BILINGUAL = 'BILINGUAL'
}


// WEBPACK FOOTER //
// ./ts/app/shared/types/bilingual-fallback-type.ts